import { IMAGES } from "../../constants/images";

// About Section - Mobile Optimized
const AboutSection = () => {
  return (
    <section className="py-16 sm:py-24 px-4 bg-[#0a0a14]" data-testid="about-section">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <p className="section-subtitle">Sobre Nosotros</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl mb-4 sm:mb-6" style={{ fontFamily: "'Cinzel', serif" }}>
              Excelencia en Cada <span className="gradient-text">Kilómetro</span>
            </h2>
            
            <div className="space-y-3 sm:space-y-4 text-sm sm:text-base text-gray-400 leading-relaxed">
              <p>
                Desde 2015, <strong className="text-white notranslate">Transfer del Sur Costa del Sol</strong> ha redefinido 
                el concepto de transporte premium en la región.
              </p>
              <p>
                Nuestros conductores son embajadores de la Costa del Sol. Hablan múltiples idiomas y conocen cada 
                rincón de la región.
              </p>
              <p>
                Cada vehículo Mercedes de nuestra flota es seleccionado meticulosamente y mantenido con los más altos 
                estándares.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-10">
              {[
                { value: "10+", label: "Años" },
                { value: "500+", label: "Clientes" },
                { value: "15K+", label: "Kilómetros" }
              ].map((stat, idx) => (
                <div key={idx} className="text-center" data-testid={`stat-${idx}`}>
                  <p className="text-2xl sm:text-3xl font-bold gradient-text">{stat.value}</p>
                  <p className="text-xs sm:text-sm text-gray-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative order-1 lg:order-2">
            <img
              src={IMAGES.interior}
              alt="Interior de lujo de nuestros vehículos Mercedes VTC Costa del Sol"
              className="rounded-xl sm:rounded-2xl w-full h-64 sm:h-[400px] lg:h-[500px] object-cover"
              loading="lazy"
            />
            <div className="absolute -bottom-4 -left-2 sm:-bottom-6 sm:-left-6 glass rounded-lg sm:rounded-xl p-4 sm:p-6">
              <div className="flex items-center gap-2 sm:gap-3">
                <i className="fas fa-award text-[#c9a962] text-xl sm:text-3xl"></i>
                <div>
                  <p className="font-semibold text-sm sm:text-base">Servicio Premium</p>
                  <p className="text-xs sm:text-sm text-gray-400">Certificado VTC</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
